import {getCachedTableStateSlice} from 'src/hooks/common-data-service/cached-table';

import type {UserAuditLogCriteria} from '../typedef';
import type {CachedTableStateSelector} from 'src/hooks/common-data-service/cached-table/typedef';


export const userAuditLogStateSlice = getCachedTableStateSlice<
    undefined,
    undefined,
    UserAuditLogCriteria
>('userAuditLogState', undefined);

export const userAuditLogStateActions = userAuditLogStateSlice.actions;
export const userAuditLogStateSelector: CachedTableStateSelector<
    undefined,
    undefined,
    UserAuditLogCriteria
> = state => state.userPage.tabs.userAuditLog.state;
